module.exports = __webpack_public_path__ + "img/instagram.98ce61e5.png";